// System directives

"use client";

// System dependencies

import React from "react";
import Link from "next/link";

// Application dependencies

import { NAV_HEADER_NAME } from "@/interfaces/nav.interfaces";
import { manageFormSpinner } from "@/lib/functions";
import { RouteFields, RouteNames } from "@/interfaces/route.interfaces";

// Props

const NavFooterLink = () => {
  // ---------------------------------------------------------------------------------------------------------------------------------------
  // Form interaction and rendering
  // ---------------------------------------------------------------------------------------------------------------------------------------

  return (
    <span onClick={() => manageFormSpinner(`loading ${RouteNames[RouteFields.Home].name} page - please wait`)}>
      <Link className="focus:outline-0" href={RouteNames[RouteFields.Home].route}>
        <span className="text-white/80">{NAV_HEADER_NAME.Prefix}</span>
        <span className="font-semibold">{NAV_HEADER_NAME.Suffix}</span>
      </Link>
    </span>
  );
};

export default NavFooterLink;
